import { render, staticRenderFns } from "./AssignableList.vue?vue&type=template&id=62f7f2b4&scoped=true&"
import script from "./AssignableList.vue?vue&type=script&lang=js&"
export * from "./AssignableList.vue?vue&type=script&lang=js&"
import style0 from "./AssignableList.vue?vue&type=style&index=0&id=62f7f2b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../Projects/register/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f7f2b4",
  null
  
)

export default component.exports